import { createContext, useContext, useEffect } from "react";

const ThemeCtx = createContext(null);

// Thème verrouillé en clair (fond blanc) sur toute la plateforme.
export function ThemeProvider({ children }) {
  useEffect(() => {
    document.documentElement.classList.remove("dark");
    try { localStorage.setItem("bvd_theme", "light"); } catch { /* ignore */ }
  }, []);
  const noop = () => {};
  return <ThemeCtx.Provider value={{ mode: "light", setMode: noop, cycle: noop }}>{children}</ThemeCtx.Provider>;
}

export const useTheme = () => useContext(ThemeCtx);
